import { FunctionComponent, memo } from 'react';
import { HorizontalStoryFeedCardProps, HorizontalStoryFeedSocialCommon } from '../../../../shared';
import { HorizontalStoryFeedCardWrapper } from '../HorizontalStoryFeedCardWrapper';
import { StoryCardQuoteContent } from '../../../../services';

export const HorizontalStoryFeedSocial: FunctionComponent<HorizontalStoryFeedCardProps> = memo(
  ({ card }) => {
    const { content } = card;
    const { quote, quoteSource, quotePersonHandle } = content as StoryCardQuoteContent;

    return (
      <HorizontalStoryFeedCardWrapper card={card}>
        <HorizontalStoryFeedSocialCommon
          quote={quote}
          quoteSource={quoteSource}
          quotePersonHandle={quotePersonHandle}
        />
      </HorizontalStoryFeedCardWrapper>
    );
  }
);
